// Shared by the navbar dropdowns and the footer columns.
// `label` is the cute display name; `id` is the plain name used in code.
// Every item is a real link in the HTML, so crawlers can follow them all.

import { IconType } from 'react-icons';
import { TbBread, TbBook, TbBuildingStore } from 'react-icons/tb';

const isDev = process.env.NODE_ENV === 'development';

export interface NavItem {
  label: string;
  description: string;
  to: string;
  external?: boolean;
  devOnly?: boolean;
}

export interface NavGroup {
  id: 'product' | 'resources' | 'company';
  label: string;
  icon: IconType;
  items: NavItem[];
}

const allNavGroups: NavGroup[] = [
  {
    id: 'product',
    label: 'Inside the Toaster',
    icon: TbBread,
    items: [
      { label: 'Features', description: 'Everything Toastie can do', to: '/features' },
      { label: "What's New", description: 'The latest updates', to: '/features/changelog' },
      { label: 'Vote on Features', description: 'Help decide what we build next', to: '/features/vote', devOnly: true },
    ],
  },
  {
    id: 'resources',
    label: 'Resources',
    icon: TbBook,
    items: [
      { label: 'Blog', description: 'Stories and health insights', to: '/blog' },
      { label: 'Quiz', description: "What's your toastie type?", to: '/quiz' },
      { label: 'FAQs', description: 'Your questions, answered', to: '/#faq' },
      // { label: 'Gift Toastie', description: 'Give the gift of health 🎁', to: '/gift' },
    ],
  },
  {
    id: 'company',
    label: 'The Bakery',
    icon: TbBuildingStore,
    items: [
      { label: 'Our Story', description: 'Meet Anna and Viv', to: '/our-story' },
      { label: 'Contact', description: 'Issues or feature requests? Get in touch', to: 'https://forms.gle/G4NptQJQPJeeav326', external: true },
      { label: 'Support Us', description: 'Buy us a coffee ☕', to: 'https://buymeacoffee.com/toastie', external: true },
    ],
  },
];

// Drop dev-only items in production, and any group left empty
export const navGroups: NavGroup[] = allNavGroups
  .map((group) => ({ ...group, items: group.items.filter((item) => isDev || !item.devOnly) }))
  .filter((group) => group.items.length > 0);
